import React, { useEffect, useState } from 'react';
import { Avatar, Pagination, Switch, Table, Tooltip } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { storeData, triggerNotification, useGetApiRequests, useSelector } from '../../common/CommonExport';
import { useDispatch } from 'react-redux';
import { setEmploymentType, setLeaveList } from '../../redux/slices/leaveListSlice';
import AddLeavePolicyModal from './AddLeavePolicyModal';
import ActiveDeactivePopup from './ActiveConfirmationPopup';

const ChapterTable = () => {
  const orgId = useSelector((state: any) => state?.organisationId?.id);
  const leavePolicyReload = useSelector((state: any) => state?.profileReload?.leavePolicyReload);
  const dispatch = useDispatch()
  const leavePloicyApi = useGetApiRequests('getLeavePolicy', 'POST');
  const getPolicyDetails = useGetApiRequests('getPolicyDetails', "GET");
  const [loader, setLoader] = useState(false);
  const [policyList, setPolicyList] = useState<any>([])

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [policyData, setPolicyData] = useState<any>({});
  const [confirmationOpen, setConfirmationOpen] = useState(false)
  const [type, setType] = useState('');
  const [record, setRecord] = useState<any>({});
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [count, setCount] = useState<number>(0);

  const onShowSizeChange = (current: number, newSize: number) => {
    setPageSize(newSize);
    setCurrentPage(1);
  };

  useEffect(() => {
    setTimeout(() => {
      const tags = document.getElementsByClassName('ant-table-content');
      if (tags.length > 1) {
        tags[1].scrollTop = 0;
      }
      getLeavePolicyApi()
    }, 100);
  }, [currentPage, pageSize, leavePolicyReload]);

  const onChange = (record: any) => {
    setRecord(record)
    if (record?.leavePolicy?.isActive === true) {
      setType('deactivate')
    } else {
      setType('activate')
    }
    setConfirmationOpen(true);
  };

  const getLeaveType = (fullName: string | null | undefined): string => {
    try {
      if (!fullName) {
        console.warn("Invalid fullName: fullName is null or undefined");
        return '';
      }

      const words = fullName.split(' ').filter(Boolean);

      if (words.length >= 2) {
        const firstNameInitial = words[0][0]?.toUpperCase();
        const lastNameInitial = words[words.length - 1][0]?.toUpperCase();
        return `${firstNameInitial}${lastNameInitial}`;
      } else if (words.length === 1) {
        return words[0][0]?.toUpperCase() || '';
      } else {
        console.warn("Invalid fullName: fullName contains no valid words");
        return '';
      }
    } catch (error) {
      console.error("An error occurred in getLeaveType:", error);
      return '';
    }
  };

  const formatLeaveTypeName = (leaveType: string | null | undefined): string => {
    if (!leaveType) return '';

    const normalizedLeaveType = leaveType.trim().toUpperCase();
    if (normalizedLeaveType === 'WFH') return 'Work From Home';
    return leaveType;
  };

  const getLeavePolicyApi = () => {
    const start: number = currentPage - 1 === 0 ? 0 : currentPage - 1;

    setLoader(true);
    const payload = {
      searchLeavePolicyDto: {
        organisationId: orgId
      },
      start: start * 10,
      limit: pageSize,
    }
    leavePloicyApi(payload)
      .then((response: any) => {
        const totalCount = response?.data?.meta?.totalRecords
        setCount(totalCount)
        const reformedPolicyList = response?.data?.data.map((item: any, index: number) => ({
          key: item?.leavePolicy?.leavePolicyId,
          name: item?.leavePolicy,
          details: item,
          leavePolicyMappingId: item?.leavePolicyMappingId,
          leavePolicy: item?.leavePolicy,
          units: item?.leavePolicy?.unit,
          leaveType: item?.leavePolicy?.policyName,
          employmentType: item.leavePolicy?.employmentTypeId === 1 ? 'Confirmed' : 'Intern'
        }));
        const leavesWeCantTake = response?.data?.data.map((item: any, index: number) => ({
          leavePolicyMappingId: item?.leavePolicyMappingId,
          leavePolicy: item?.leavePolicy?.policyName,
          key: item?.leavePolicy?.leavePolicyId,
          employmentType: item.leavePolicy?.employmentTypeId === 1 ? 'Confirmed' : 'Intern',
          checked: false
        }));
        dispatch(setLeaveList(leavesWeCantTake))
        setPolicyList(reformedPolicyList);
        setTimeout(() => {
          setLoader(false)
        }, 1000)
      })
      .catch((err: any) => {
        setTimeout(() => {
          setLoader(false)
        }, 1000)
        triggerNotification('error', '', err?.message, 'topRight');
      });
  };

  const setModalOpen = () => {
    setIsModalVisible(true)
  }
  const getPolicyDetailsApi = (record: any) => {
    storeData('leavePolicyMappingId', record?.leavePolicyMappingId, true);
    const employmentType = record?.leavePolicy?.employmentTypeId === 1 ? 'Confirmed' : 'Intern'
    dispatch(setEmploymentType(employmentType))
    setLoader(true);
    const params = {
      leavePolicyMappingId: record?.leavePolicyMappingId
    }
    getPolicyDetails('', {}, params)
      .then((response: any) => {
        setTimeout(() => {
          setLoader(false)
        }, 1000)
        setPolicyData(response?.data?.data)
        setModalOpen()
      })
      .catch((err: any) => {
        setTimeout(() => {
          setLoader(false)
        }, 1000)
        triggerNotification('error', '', err?.message, 'topRight');
      });
  }
  const columns: ColumnsType<any> = [
    {
      title: 'Types',
      dataIndex: 'leaveType',
      width: "25%",
      render: (text) => {
        const displayLeaveType = formatLeaveTypeName(text);
        return (
          <div className='flex items-center leave-type'>
            <Avatar.Group
              maxCount={3}
              maxPopoverTrigger="click"
              size="large"
              maxStyle={{ color: '#f56a00', backgroundColor: '#fde3cf', cursor: 'pointer' }}
            >
              <Avatar className={"leave-type-" + text} >{getLeaveType(displayLeaveType)}</Avatar>
            </Avatar.Group>
            <p className='ml-2'>{displayLeaveType}</p>
          </div>
        )
      },
    },
    {
      title: 'Employment type',
      dataIndex: 'employmentType',
      width: "25%",

    },
    {
      title: 'Units ',
      dataIndex: 'units',
      width: "30%",
    },
    {
      title: "Active status",
      dataIndex: 'action',
      key: 'action',
      render: (_: any, record: any) => (
        <div className='flex'>
          <Switch checked={record?.details?.leavePolicy?.isActive} onChange={() => onChange(record)} />
        </div>
      ),
    },
    {
      title: 'Action',
      dataIndex: 'editButton',
      render: (_: any, record: any) => (
        <div className='flex'>
          <Tooltip placement="top" title="Edit">
            <span className="material-symbols-outlined mr-4 cursor-pointer hover:text-primary" onClick={() => getPolicyDetailsApi(record)} >Edit</span>
          </Tooltip>
        </div>
      ),
    },
  ]

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <div className='leave-management user-table head'>
      <Table columns={columns} dataSource={policyList} loading={loader} pagination={false} />
      <div className='pagination'>
        <Pagination
          className='float-right flex flex-row p-6'
          showSizeChanger
          onShowSizeChange={onShowSizeChange}
          current={currentPage}
          total={count}
          pageSize={pageSize}
          onChange={(page) => setCurrentPage(page)}
        />
      </div>
      {isModalVisible && <AddLeavePolicyModal open={isModalVisible} handelClose={handleCancel} isEdit={true} policyData={policyData} />}
      {confirmationOpen && <ActiveDeactivePopup closeConfirmationModal={confirmationOpen} setCloseConfirmationModal={setConfirmationOpen} type={type} record={record} />}
    </div>
  )
}

export default ChapterTable
